export default __webpack_public_path__ + "static/media/k1.b6f1ec4e.png";